import React, { useContext } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import AuthState from '../../context/autenticacion/authContext';

const BotonesForm = () => {

    // Extraer si un proyecto está activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, verdetalles, verDetalles, obtenerAlturaContenedor } = proyectosContext;

    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const { vertarea, limpiarTarea, verTarea, esconderFormulario, limpiarDescripcion, tareaActual, formularioDescripcion } = tareasContext;

    // Extraer usuario logeado
    const authState = useContext(AuthState);
    const { usuario } = authState;

    // Si no hay proyecto seleccionado
    if(!proyecto) return null;


    // Cambiar a la vista deseada
    const cambiarVista = (boton1, boton2, status) => {
        const btn1 = document.getElementById(boton1);
        const btn2 = document.getElementById(boton2);
        
        btn1.classList.add('active');
        btn2.classList.remove('active');
        
        verDetalles(status);
        limpiarTarea();
        limpiarDescripcion();
        tareaActual('');
        formularioDescripcion(false);
        
        // Segun a donde vaya se actualiza la altura
        if(status){
            obtenerAlturaContenedor(window.innerHeight - 56 - 131.8);
        }else {
            obtenerAlturaContenedor(window.innerHeight - 56 - 247);
        }

        if(!vertarea || !verdetalles){
            esconderFormulario(status);
        }

        // Si estaba en ver tarea
        if(vertarea){
            verTarea(false);
        }
    }

    return ( 
        <div className="contenedor-btns">
            <div className="btns">
                <button
                    id="btn-tareas"
                    className={`active ${usuario ? usuario.rol !== 'Administrador' ? 'disabled' : '' : null}`}
                    onClick={() => cambiarVista('btn-tareas', 'btn-detalles', false)}
                >Tareas</button>
            </div>
            {
                usuario ? (
                    usuario.rol === 'Administrador' ? (
                        <div className="btns">
                            <button
                                id="btn-detalles"
                                onClick={() => cambiarVista('btn-detalles', 'btn-tareas', true)}
                            >Detalles</button>
                        </div>
                    ) : null
                ) : null
            }
        </div>
    );
}

export default BotonesForm;